module.exports = __webpack_public_path__ + "img/ico_user.4b31cd55.svg";